export default __webpack_public_path__ + "images/13cd0c5dcc999e0ea09016bc1f5fb7c7.png";